"use strict";
/**
 * Stock Calculation Response Types
 *
 * Response DTOs for stock calculation endpoints.
 */
Object.defineProperty(exports, "__esModule", { value: true });
